<!-- 系统安全加固方案 -->
<template>
  <div class="page_html">
    <div class="banner">
      <img
        src="@/assets/solution/enterprise/solution_banner.png"
        alt=""
      >
      <div class="banner_Title">
        <div class="title">
          {{ title }}
        </div>
        <div class="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        服务应用场景
      </p>
      <div class="scenes">
        <div
          v-for="pic in pics"
          :key="pic.id"
          class="scene"
        >
          <img
            :src="pic.src"
            alt=""
          >
        </div>
      </div>
      <div class="texts">
        <div
          v-for="item in texts"
          :key="item.id"
          class="text"
        >
          {{ item }}
        </div>
      </div>
    </div>

    <div class="introduce background">
      <p class="sub_title">
        系统安全加固流程
      </p>
      <div class="content_text">
        针对客户网络中的重要业务系统从源头进行安全能力提升,提高漏洞修复的准确性,实现及时、有效的系统安全防护,从而确保业务系统持续加强自身的安全性，大幅度降低网络及业务系统被攻击的可能性。
      </div>
      <div class="process">
        <img
          src="@/assets/solution/systemSecurityReinforcement/circle.png"
          alt=""
        >
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        方案价值
      </p>
      <div class="values">
        <div
          v-for="item in values"
          :key="item.id"
          class="value"
        >
          <div class="number">
            {{ item.number }}
          </div>
          <div class="text">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SystemSecurityReinforcement',
  data() {
    return {
      title: '系统安全加固方案',
      subtitle: '系统安全是网络安全最基本的工作,安全基础的建设情况会直接影响到上层数字化运营的安全防护工作。为避免出现纵深防御和积极防御根基不牢的情况,灵创科技以"资”、“配” 、"漏”、 “补”为基础,通过检测威胁系统安全的潜在漏洞,持续地监视和加固系统安全配置,并采取适当的补救措施,从而达到不断收缩攻击暴露面、减少安全隐患的目标，实现数字化运营所需要的高水平安全保障。',
      pics: [
        { src: require('@/assets/solution/systemSecurityReinforcement/zuzhiguanli.png') },
        { src: require('@/assets/solution/systemSecurityReinforcement/ziyuanguanli.png') },
        { src: require('@/assets/solution/systemSecurityReinforcement/gongnengguanli.png') },
        { src: require('@/assets/solution/systemSecurityReinforcement/yunfenxiang.png') }

      ],
      texts: [
        '资产掌握不全面，有“未知”资产的存在。',
        '防火墙、操作系统等资产配置策略过于粗放,起不到真正防护效果。',
        '不清楚业务系统存在的漏洞和面临的风险。',
        '明知系统存在漏洞,不敢打补丁,担心影响系统的正常运行。'
      ],
      values: [
        {
          id: 1,
          number: '01',
          text: '针对安全产品本身只具备基础安全功能的问题，提供成熟完善的安全服务流程，进一步弥补传统网络安全设备的短板。'
        },
        {
          id: 2,
          number: '02',
          text: '化被动防护为主动防，变静态防护为动态防护，加强网络安全建设，不断循环升级，实现核心资产与业务系统的动态守护。'
        },
        {
          id: 3,
          number: '03',
          text: '以人机结合手段摸清家底，帮助用户运维人员开展后续工作,减少运维工作量，提升用户网络与信息系统的综合运维质量。'
        },
        {
          id: 4,
          number: '04',
          text: '解决用户资产不清、漏洞不明、配置不当,修补繁琐等实际安全问题，为后期的综合安全运营打好基础。'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .banner {

    height: 550px;

    img{
      width: 100%;
      height: 100%;
    }

    .banner_Title {
      position: absolute;
      top: 15%;
      left: 15%;
      width: 80%;

      .title {
        width: 56%;
        font-size: 54px;
        color: #ffffff;
        font-weight: bold;
      }

      .subtitle {
        width: 76%;
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin-top: 30px;
      }
    }
  }

  .scenes {
    width: 70%;
    margin: 0 auto ;
    display: flex;
    justify-content: space-around;
    padding-top: 50px;

    .scene {
      width: 200px;
      height: 283px;
      display: flex;
      justify-content: center;

      img {
        width: 236px;
        height: 236px;

      }
    }

  }

  .texts {
    width: 70%;
    margin: 0 auto;
    display: flex;
    box-shadow: 0px 0px 14px 3px #dee4f2;
    border-radius: 15px;
    justify-content: space-between;
    margin-bottom: 125px;

    .text {
      width: 24%;
      display: flex;
      justify-content: center;
      height: 250px;
      border-radius: 15px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      align-items: center;
      padding: 0 62px;
      text-align-last: center;
      position: relative;
      &:not(:last-child){
        &::before{
          position: absolute;
          content: '';
          height: 65%;
          border-right: 1px dotted #000;
          right: 0;
          top: 50%;
          transform:  translateY(-50%);
        }
      }
    }
  }

  .content_text {
    width: 70%;
    margin: 0 auto;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
  }

  .process {
    width: 70%;
    margin: 0 auto;
    height: 550px;
    padding-top: 76px;
    display: flex;
    justify-content: center;

    img{
      max-width: 100%;
    }
  }

  .background {
    padding: 100px 0 143px;
    background: #FAFBFF;
  }

  .values {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 177px;
    padding-top: 40px;

    .value {
      width: 24%;
      height: 560px;
      background: #E1E5F8;
      border-radius: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .number {
        width: 95px;
        height: 95px;
        background: #FFFFFF;
        border-radius: 50%;
        font-size: 48px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #425DEC;
        line-height: 95px;
        text-align: center;
        margin: 70px 0 70px;
      }

      .text {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        margin: 0 58px;
      }
    }
  }
}

@media (max-width: 750px)and (max-width: 1250px) {
  .banner .banner_Title .title {
    width: 74% !important;
  }

  .page_html .banner .banner_Title .title {
    font-size: 30px !important;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .banner .banner_Title .title {
    width: 74% !important;
    font-size: 37px !important;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 20px;
  }

  .banner{
    height: 400px !important;
  }
  .page_html .scenes,
  .page_html .texts,
  .page_html .content_text,
  .page_html .values{
    width: 85% !important;
  }

  .page_html .texts .text{
    font-size: 18px;
  }

  .page_html .values .value .number{
    margin: 60px 0 60px;
  }

  .page_html .values .value .text{
    margin: 0px 41px;
  }
  .page_html .content_text{
     font-size: 20px;
  }

}

@media screen and (min-width: 1350px) and (max-width: 1500px) {
  .banner .banner_Title .title {
    width: 74% !important;
    font-size: 40px !important;
  }
  .page_html .content_text{
    font-size: 22px;
  }

  .page_html .scenes,
  .page_html .texts,
  .page_html .content_text,
  .page_html .values{
    width: 80% !important;
  }
  .page_html .banner .banner_Title .subtitle {
    font-size: 25px;
  }
  .banner{
    height: 450px !important;
  }
  .page_html .texts .text{
    font-size: 18px;
  }

  .page_html .values .value .number{
    margin: 60px 0 60px;
  }

  .page_html .values .value .text{
    margin: 0px 41px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .banner .banner_Title .title {
    width: 90% !important;
    font-size: 52px !important;
  }

  .banner .banner_Title .subtitle {
    font-size: 30px !important;
  }

  .page_html .scenes,
  .page_html .texts,
  .page_html .content_text,
  .page_html .values{
    width: 75% !important;
  }
}
</style>
